// Toast : un seul à la fois, en bas, annoncé aux lecteurs d'écran ; un nouveau message remplace le texte et
// relance le minuteur sans rejouer l'entrée. Entrée 180 ms, sortie 120 ms, puis retiré du DOM.
// opts : { type: 'danger', icone, duree, action: { label, fn } } — l'action (« Annuler ») tient le toast plus longtemps.
import { ico } from '../icones.js';
var conteneur = null, courant = null, minuteur = null;
function boite() {
    if (!conteneur) { conteneur = document.createElement('div'); conteneur.className = 'toasts'; conteneur.setAttribute('role', 'status'); conteneur.setAttribute('aria-live', 'polite'); document.body.appendChild(conteneur); }
    return conteneur;
}
export function toast(texte, opts) {
    opts = opts || {};
    clearTimeout(minuteur);
    var classes = 'toast' + (opts.type === 'danger' ? ' toast-danger' : '');
    var t = courant;
    if (t) {
        t.className = classes + ' visible';
        var span = t.querySelector('.toast-texte'); if (span) span.textContent = texte;
        var ancien = t.querySelector('.toast-action'); if (ancien) ancien.remove();
    } else {
        t = document.createElement('div');
        t.className = classes;
        t.innerHTML = (opts.icone ? ico(opts.icone, { taille: 16 }) : '') + '<span class="toast-texte"></span>';
        var texteEl = t.querySelector('.toast-texte'); if (texteEl) texteEl.textContent = texte; else t.textContent = texte;
        boite().appendChild(t);
        courant = t;
        requestAnimationFrame(function() { requestAnimationFrame(function() { if (courant === t) t.classList.add('visible'); }); });
    }
    if (opts.action && opts.action.fn) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'toast-action'; b.textContent = opts.action.label || 'Annuler';
        b.addEventListener('click', function() { fermerToast(); opts.action.fn(); });
        t.appendChild(b);
    }
    minuteur = setTimeout(fermerToast, opts.duree || (opts.action ? 6000 : 2600));
}
export function fermerToast() {
    var t = courant; if (!t) return;
    courant = null;
    t.classList.add('sortie');
    setTimeout(function() { t.remove(); }, 160);
}
// Nom historique : tout le moteur appelle undoMessage(txt) pour n'importe quel message court.
window.undoMessage = function(txt) { toast(txt); };
window.toast = toast;
